/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
		}

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, {
				passive: true
			});
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
				if (y > this.pageHeight) {
					this.classList.add('back-to-top--active');
				} else {
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}



// ======================= tooltop code
// let tooltip = null;

// // Function to create and show tooltip
// const showTooltip = (addToCartButton) => {
//   // Don't show tooltip if button is not disabled
//   if (!addToCartButton.disabled) return;
  
//   // Remove existing tooltip if any
//   hideTooltip();
  
//   tooltip = document.createElement('div');
//   tooltip.className = 'tooltip-1511';
//   tooltip.style.cssText = `
//     position: absolute;
//     display: block;
//     background: #4caf50;
//     color: #ffffff;
//     padding: 5px 10px;
//     border-radius: 4px;
//     font-size: 14px;
//     white-space: nowrap;
//     z-index: 1000;
//   `;
//   tooltip.innerText = 'Please enter a pincode!';

//   const arrow = document.createElement('div');
//   arrow.className = 'arrow-bottom-1511';
//   arrow.style.cssText = `
//     position: absolute;
//     top: 100%;
//     left: 20px;
//     width: 0;
//     height: 0;
//     border-left: 5px solid transparent;
//     border-right: 5px solid transparent;
//     border-top: 5px solid #4caf50;
//   `;

//   tooltip.appendChild(arrow);

//   const rect = addToCartButton.getBoundingClientRect();
//   tooltip.style.left = `${rect.left + window.scrollX + 10}px`;
//   tooltip.style.top = `${rect.top + window.scrollY - 45}px`;

//   document.body.appendChild(tooltip);
// };

// // Function to hide tooltip
// const hideTooltip = () => {
//   if (tooltip) {
//     document.body.removeChild(tooltip);
//     tooltip = null;
//   }
// };

// // Function to setup button styles and events
// const setupButton = (addToCartButton) => {
//   if (!addToCartButton) return;

//   const styleSheet = document.styleSheets[0];
//   styleSheet.insertRule(
//     `.single-add-to-cart-button:disabled::before {
//       background: none !important;
//     }`,
//     styleSheet.cssRules.length
//   );

//   if (addToCartButton.previousElementSibling) {
//     addToCartButton.previousElementSibling.style.cssText = 'display: none !important;';
//   }
  
//   addToCartButton.style.pointerEvents = 'auto';
//   addToCartButton.title = 'Enter pin code first';

//   // Remove existing event listeners before adding new ones
//   addToCartButton.removeEventListener('mouseover', () => showTooltip(addToCartButton));
//   addToCartButton.removeEventListener('mouseout', hideTooltip);

//   // Only add event listeners if button is disabled
//   if (addToCartButton.disabled) {
//     addToCartButton.addEventListener('mouseover', () => showTooltip(addToCartButton));
//     addToCartButton.addEventListener('mouseout', hideTooltip);
//   }
// };

// // Function to remove button events
// const removeButtonEvents = (addToCartButton) => {
//   if (!addToCartButton) return;
  
//   addToCartButton.removeEventListener('mouseover', () => showTooltip(addToCartButton));
//   addToCartButton.removeEventListener('mouseout', hideTooltip);
//   hideTooltip();
  
//   // Reset button styles
//   addToCartButton.style.pointerEvents = '';
//   addToCartButton.title = '';
// };

// // Initial setup
// const addToCartButton = document.querySelector('#AddToCartSticky');
// if (addToCartButton?.disabled) {
//   setupButton(addToCartButton);
// }

// // Setup observer
// const productAddToCartContainer = document.querySelector('.product-add-to-cart-container');
// if (productAddToCartContainer) {
//   const config = {
//     childList: true,
//     subtree: true,
//     attributes: true, // Added to watch for attribute changes
//     attributeFilter: ['disabled'] // Only watch the disabled attribute
//   };

//   const callback = function(mutationsList, observer) {
//     for (const mutation of mutationsList) {
//       const addToCartButton = document.querySelector('#AddToCartSticky');
//       if (!addToCartButton) continue;

//       // Check for both childList changes and attribute changes
//       if (mutation.type === 'childList' || 
//           (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
        
//         if (addToCartButton.disabled) {
//           setupButton(addToCartButton);
//         } else {
//           removeButtonEvents(addToCartButton);
//         }
//       }
//     }
//   };

//   const observer = new MutationObserver(callback);
//   observer.observe(productAddToCartContainer, config);
// }